// extracted by mini-css-extract-plugin
module.exports = {"sharingBox":"style_sharingBox__1HYWq","sharingButton":"style_sharingButton__2Lt73"};